module.exports = __webpack_public_path__ + "img/ZoomBlue&Black.f18f9aec.png";